module.exports = "/images/ingredients-2.png";